<template>
    <v-app>
        <template v-if="session.authenticated && !guestRoute">
            <ImpersonationBar v-if="session.impersonating" />
            <AppNavigation />
        </template>
        <v-main>
            <div class="app-page">
                <router-view class="app-page__view" />
                <footer class="app-page__footer text-caption text-medium-emphasis">
                    <img v-if="guestRoute" src="/img/tricolorcircle.svg" alt="" class="app-page__mark" />
                    <span v-if="guestRoute">Powered by Optimized Tech</span>
                    <span class="mono">v{{ displayVersion }}</span>
                </footer>
            </div>
        </v-main>
    </v-app>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useTheme } from "vuetify";
import AppNavigation from "@/components/AppNavigation.vue";
import ImpersonationBar from "@/components/ImpersonationBar.vue";
import { useSessionStore } from "@/store/session";

const session = useSessionStore();
const route = useRoute();
const theme = useTheme();
const guestRoute = computed(() => route.matched.some((r) => r.meta["guest"] === true));
// The tracker is framed on manufacturers' own pages, which are light, so it ignores the visitor's preference
const activeTheme = computed(() => (route.matched.some((r) => r.meta["theme"] === "light") ? "light" : session.theme));
watch(activeTheme, (name) => (theme.global.name.value = name), { immediate: true });
// The assembly version carries the commit hash after a plus sign
const displayVersion = computed(() => session.version?.split("+")[0] ?? "");
</script>

<style lang="scss">
.app-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;

    &__view {
        flex: 1 0 auto;
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        padding: 8px 20px;
    }

    &__mark {
        height: 16px;
        width: auto;
    }
}
</style>
